import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function WebhooksSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Webhooks"
      description="Outbound HTTP callbacks on asset / comment / approval events. Deferred to Phase 2."
    />
  );
}
